var map = {
	"./instantMessaging/custom_avatar.svg": "ddf9",
	"./instantMessaging/ic_arrow_down.svg": "ce86",
	"./instantMessaging/ic_back.svg": "9211",
	"./instantMessaging/ic_comment.svg": "9b0c",
	"./instantMessaging/ic_comment_success.svg": "e331",
	"./instantMessaging/ic_commodity.svg": "f55d",
	"./instantMessaging/ic_commonly_grey.svg": "619e",
	"./instantMessaging/ic_commonly_yellow.svg": "1335",
	"./instantMessaging/ic_dissatisfied_grey.svg": "92d1",
	"./instantMessaging/ic_dissatisfied_yellow.svg": "c713",
	"./instantMessaging/ic_emoji.svg": "0e46",
	"./instantMessaging/ic_files.svg": "5769",
	"./instantMessaging/ic_invite.svg": "bda2",
	"./instantMessaging/ic_order.svg": "954e",
	"./instantMessaging/ic_person.svg": "9ebd",
	"./instantMessaging/ic_picture.svg": "0adf",
	"./instantMessaging/ic_read.svg": "51f8",
	"./instantMessaging/ic_satisfied_grey.svg": "dd6a",
	"./instantMessaging/ic_satisfied_yellow.svg": "e0eb",
	"./instantMessaging/ic_talking_green.svg": "cf09",
	"./instantMessaging/ic_toolbar.svg": "e9a0",
	"./instantMessaging/ic_voice.svg": "df1b",
	"./instantMessaging/icon_files.svg": "66ff",
	"./instantMessaging/icon_picture.svg": "a43f",
	"./instantMessaging/staff_avatar.svg": "0cff",
	"./itineraryUniversal/ic-arrow.svg": "7ef7",
	"./itineraryUniversal/ic-bottom-popup-close.svg": "215c",
	"./itineraryUniversal/ic-check.svg": "abd3",
	"./itineraryUniversal/ic-clock-line.svg": "1866",
	"./itineraryUniversal/ic-copy.svg": "e15f",
	"./itineraryUniversal/ic-download.svg": "5851",
	"./itineraryUniversal/ic-eye-close.svg": "0a65",
	"./itineraryUniversal/ic-eye-open.svg": "13db",
	"./itineraryUniversal/ic-guide-card.svg": "03de",
	"./itineraryUniversal/ic-location.svg": "8fac",
	"./itineraryUniversal/ic-phone.svg": "b332",
	"./itineraryUniversal/ic-popup-close.svg": "110c",
	"./itineraryUniversal/ic-qrcode.svg": "c10c",
	"./itineraryUniversal/ic-time.svg": "a0e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";